// Input con tokens del sistema. Estilos para focus, disabled y aria-invalid
// (error) usan tokens semánticos: accent en focus ring, crit en invalid.

import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, type = 'text', ...props }, ref) {
    return (
      <input
        type={type}
        ref={ref}
        className={cn(
          'flex h-10 w-full rounded border border-border bg-surface-input px-3 py-2 text-sm text-fg',
          'placeholder:text-fg-tertiary',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:text-fg-disabled',
          'aria-invalid:border-crit aria-invalid:ring-crit',
          className,
        )}
        {...props}
      />
    );
  },
);
